import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
// Shared build-variant helpers for KGOnline web + MFSetu mobile apps.
export const APP_VARIANT = String(process.env.REACT_APP_APP_VARIANT || "web").toLowerCase();
export const APP_PLATFORM = String(process.env.REACT_APP_PLATFORM || "web").toLowerCase();
export const APP_VERSION = String(process.env.REACT_APP_APP_VERSION || "").trim();
export const APP_VERSION_CODE = Number.parseInt(process.env.REACT_APP_VERSION_CODE || "0", 10) || 0;

export const IS_MFD_APP = APP_VARIANT === "mfd";
export const IS_MYWEALTH_APP = APP_VARIANT === "mywealth";
export const IS_MOBILE_APP = IS_MFD_APP || IS_MYWEALTH_APP;


export async function getRuntimeAppMetadata() {
  const fallback = {
    platform: APP_PLATFORM || (Capacitor.isNativePlatform() ? Capacitor.getPlatform() : "web"),
    app_variant: APP_VARIANT,
    app_version: APP_VERSION,
    app_version_code: APP_VERSION_CODE,
  };

  if (!Capacitor.isNativePlatform()) return fallback;

  try {
    const info = await App.getInfo();
    return {
      platform: Capacitor.getPlatform() || fallback.platform,
      app_variant: APP_VARIANT,
      app_version: String(info?.version || APP_VERSION || "").trim(),
      app_version_code: Number.parseInt(String(info?.build || APP_VERSION_CODE || "0"), 10) || 0,
    };
  } catch (_) {
    return fallback;
  }
}
